import { QuestionCircleOutlined } from '@ant-design/icons'
import LoginSub from '@components/LocalMerchant/SiDa/Common/LoginSub'
import SiYiMember from '@components/LocalMerchant/SiDa/Common/SiYiMember'
import { dGet } from '@core/utils'
import { getMoney } from '@hlj/hlj-utils'
import { isUltimate } from '@merchant-backend/util'
import { isSiDaMember, isSiDaTeam } from '@util'
import { Switch, Tooltip } from 'hljd'
import React from 'react'

export default store => [
  {
    title: '成员',
    dataIndex: 'info',
    width: 300,
    render: (t, record) => {
      return (
        <SiYiMember
          item={record}
          showWarning={true}
          showNumbers={false}
          showPrice={false}
          showBusy={false}
        />
      )
    }
  },
  {
    title: '评分',
    dataIndex: 'score',
    width: 80,
    sorter: true,
    render: (o, { merchantComment }) => dGet(merchantComment, 'score') || '-'
  },
  /*{
    title: '好评数',
    dataIndex: 'totalGoodCount',
    width: 100,
    sorter: true,
    render: (o, { merchantComment }) => dGet(merchantComment, 'totalGoodCount')
  },*/
  {
    title: (
      <div>
        <span style={{ marginRight: 3 }}>档期数</span>
        <span>
          <Tooltip
            title="成员记录在档期管理工具中，未来一年的档期数量"
            getPopupContainer={() => document.body}
          >
            <QuestionCircleOutlined style={{ cursor: 'pointer' }} />
          </Tooltip>
        </span>
      </div>
    ),
    dataIndex: 'emceeSchedulesCount',
    width: 120,
    sorter: true
  },
  {
    title: '价格',
    dataIndex: 'minPrice',
    width: 100,
    render: minPrice => getMoney(minPrice),
    sorter: true
  },
  {
    title: '联系电话',
    dataIndex: 'shopPhone',
    width: 100,
    hidden: () => !isSiDaTeam()
  },
  {
    title: '是否显示',
    dataIndex: 'isMemberShow',
    width: 100,
    render: (isMemberShow, { id }) => {
      return (
        <Switch
          checked={isMemberShow == 1}
          onChange={data => store.setMemberShow(data, id)}
        />
      )
    },
    hidden: () => !isSiDaTeam()
  },
  {
    title: '状态',
    dataIndex: 'examine',
    render: (text, record) => getStatus(record),
    width: 120,
    hidden: () => !isSiDaTeam()
  },
  {
    title: '加入时间',
    dataIndex: 'joinAt',
    render: joinAt => {
      return joinAt ? joinAt.split(' ')[0] : null
    },
    width: 120,
    sorter: true
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: 120,
    render: (o, { id, mStoreId, examine, tempId }) => {
      /*if (!isSiDaTeam() && examine == 1) {
        return (
          <a
            onClick={() => {
              goToSiYiMemberHome(id)
            }}
          >
            查看主页
          </a>
        )
      }*/

      return (
        <div>
          {examine == 1 && (
            <div>
              <LoginSub storeId={mStoreId}>登录管理</LoginSub>
            </div>
          )}
          <div style={{ marginTop: 8 }}>
            <a onClick={() => store.removeFromTeam(id, tempId)}>移出团队</a>
          </div>
        </div>
      )
    },
    hidden: () => isSiDaMember()
  }
]

const getStatus = ({
  isPro,
  examine,
  isRegisterImprove,
  certify = {},
  status
}) => {
  // isPro： 2旗舰版
  // examine：店铺第一次审核状态 -1(未填写)，0（审核中），1（审核通过）, 2(审核拒绝)
  // certify: 实名认证状态 0：未提交，1：审核中，2：未通过，3：通过
  // status：其他时候的状态 0：审核中，1：未通过，2：通过
  // isRegisterImprove：1已完善资料，0未完善资料
  //
  let dom
  if (isRegisterImprove == 0) {
    dom = <span style={{ color: '#FF8C30' }}>待完善资料</span>
  } else if (examine == 1) {
    dom = (
      <>
        <span>审核通过</span>
        <br />
        <span style={{ color: '#999999' }}>
          {isUltimate(isPro) ? '(已开通商家服务)' : '(未开通商家服务)'}
        </span>
      </>
    )
  } else if (certify.status == 2 || status == 1 || examine == 2) {
    dom = <span style={{ color: '#FF5C5C' }}>审核未通过</span>
  } else if (certify.status == 1 || status == 0 || examine == 0) {
    dom = <span>待审核</span>
  }
  return dom
}
